function writeToListForXML(data, list, close_key = undefined) {
  let key;
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      let element = data[i];
      for (let keyOfElement in element) {
        key = keyOfElement;
        break;
      }
      if (Array.isArray(element[key])) {
        list += '<div class="xml-response-item">' + '&lt' + key + '&gt';
        list = writeToListForXML(element[key], list, key);
      } else {
        if (key === 'redirect-url') {
          list += '<div class="xml-response-item">' + '&lt' + key + '&gt' + '<a class="xml-response-item__link" href="' + element[key]
            + '"' + '>' + element[key] + '</a>' + '&lt' + '/' + key + '&gt' + '</div>';
        } else {
          list += '<div class="xml-response-item">' + '&lt' + key + '&gt' + element[key] + '&lt' + '/' + key + '&gt' +
            '</div>';
        }
      }
    }
    if (close_key != undefined) {
      list += '&lt' + '/' + close_key + '&gt' + '</div>';
    }
  }
  return list;
}

function XmlToArray(data) {
  let parser = new DOMParser();
  let doc1 = parser.parseFromString(data, "text/xml");
  const responseElem = doc1.getElementsByTagName('response')[0];
  if(!responseElem) return null;
  return getChildTagsFromParentTag(doc1.getElementsByTagName('response')[0]);
}

function getChildTagsFromParentTag(element) {
  if(!element.childElementCount) return null;
  let res = [];
  for (let i = 0; i < element.childElementCount; i++) {
    let child_element = element.children[i];
    let child_name = child_element.tagName;
    // if child has own children, use this function again for this child
    if (child_element.children[0] != null) {
      res.push({});
      res[res.length - 1][child_name] = getChildTagsFromParentTag(child_element)
    }
    // if current element doesn't have children, write it to dictionary
    else {
      res.push({});
      res[res.length - 1][child_name] = child_element.childNodes[0].data;
    }
  }

  return res;
}

export default function showResponseInXMLFormat(data) {
  let info = XmlToArray(data);
  if(!info) return data;
  let list = '';
  list += '<div class="xml-response-item">' + '&lt' + '?xml version="1.0" encoding="UTF-8"?' + '&gt';
  list += '<div class="xml-response-item"">' + '&lt' + 'response' + '&gt';
  list = writeToListForXML(info, list);
  list += '&lt' + '/response' + '&gt' + '</div>';
  list += '</div>';
  return list;
}
